<template>
    <div class="other-card" >
        <div class="other-card__inner">
            <h4 class="other-card__title">
                <a :href="`/${data.url}`" @click="handleClick('phone_number', $event)">{{ data.title }}</a>
            </h4>
            <template v-if="data.type === 'event'">
                <div class="js-hide" ref="body" v-html="data.excerpt" />
            </template>
            <template v-else>
                <div class="js-hide" ref="body" v-html="data.body || data.bio" />
            </template>
            <p class="other-card__info">
                {{ truncated }}
            </p>
        </div>
    </div>
</template>

<script>
import Personnel from '../types/personnel.vue';
import { swiftypeClickMixin } from '../../../scripts/mixins';

export default {
    name: 'other',
    props: ['data', 'requestId', 'query'],
    mixins: [swiftypeClickMixin],
    components: {
        Personnel,
    },
    mounted() {
        this.body = this.$refs.body.innerText;
    },
    updated() {
        this.body = this.$refs.body.innerText;
    },
    data: () => ({
        body: ''
    }),
    computed: {
        truncated() {
            let body = this.body;

            if (body.length > 100) {
                return `${body.substring(0, 100)}...`;
            }

            return body;
        }
    }
}
</script>

